// extracted by mini-css-extract-plugin
export default {"container":"Auth_container__+QBmc","form":"Auth_form__XN5HX","infoMessage":"Auth_infoMessage__+-GuW","actions":"Auth_actions__O3xzj"};